import { h } from "preact";
import { Card, Typography } from "antd";


export default function AccessDenied(props) {

    return (
        <Card
            bordered={false}
            title={
                <Typography.Title
                    level={4}
                >
                    403 FORBIDDEN!
                </Typography.Title>}
        >
            Access Denied! You don't have permission to access the requested content!
        </Card>
    )
}